<template>
    <el-container class="exam">
        <el-main>
            <!-- 绑定机构 -->
            <div class="information">
                <div class="line jf fristLine">
                    <span class="header">当前机构：</span>
                    <el-link type="primary" :underline="false">{{
                            userForm.OrganName | filterOrgName
                    }}</el-link>
                </div>
                <div class="line jf">
                    <span class="header">当前用户组：</span>
                    <el-link type="primary" :underline="false">{{
                        userForm.UserGroup | filterGroup($store.state.userInfo.OrganName)
                    }}</el-link>
                    <el-tag
                        v-if="userForm.State && isShowUserGroup"
                        type="info"
                        size="mini"
                        style="margin-left:20px;font-size:12px"
                        >{{ userForm.State }}</el-tag
                    >
                </div>
                <div class="line jf">
                    <div class="bing-line"></div>
                </div>
                <div class="line jf" style="margin:30px 0 20px 0;">
                    <span class="header">
                        <el-tag type="success" style="font-size:13px;"
                            >重新绑定</el-tag
                        >
                    </span>
                </div>
                <div class="line jf">
                    <span class="header">选择机构：</span>
                    <el-select
                        v-model="userForm.GroupUserId"
                        filterable
                        remote
                        clearable
                        reserve-keyword
                        placeholder="请输入关键字检索机构..."
                        class="tab-text"
                        :remote-method="GetOrganInfo"
                        @change="GetOrganLevelInfo"
                    >
                        <el-option
                            v-for="item in organData"
                            :key="item.ID"
                            :label="item.Name"
                            :value="item.ID"
                        ></el-option>
                    </el-select>
                </div>
                <div class="line jf">
                    <span class="header">选择用户组：</span>
                    <el-cascader
                        v-model="organLeverId"
                        ref="organSelect"
                        :options="organLeverData"
                        :props="{ checkStrictly: true }"
                        clearable
                        class="tab-text"
                        placeholder="请选择用户组..."
                        @change="organLeverChange"
                    ></el-cascader>
                </div>
                <div class="line jf">
                    <span class="header"></span>
                    <div v-loading="isDisable" class="saveBtn xy-center" @click="UserOrganLevelApply">
                        申请绑定
                    </div>
                </div>
            </div>
            <!-- 绑定机构 -->
        </el-main>
    </el-container>
</template>

<script>
import { GetUserOrganLevelInfo, UserOrganLevelApply } from "@/api/user";
import { GetOrganInfoByKeyword, GetOrganLevelInfo } from "@/api/organ";
import { removeEmptyChildren } from "@/utils";
import { last } from "lodash";

export default {
    components: {},
    created() {
        this.getUserInfo();
    },
    data() {
        return {
            // 用户表单
            userForm: {
                ID: "",
                OrganName: "",
                GroupUserId: "",
                UserGroup: null,
                State: ""
            },
            // 机构信息
            organData: [],
            // 机构用户组信息
            organLeverData: [],
            organId: "",
            organName: "",
            organLeverId: null,
            organLeverName: "",
            isDisable: false,
        };
    },
    computed: {
        isShowUserGroup () {
            const { UserGroup } = this.userForm
            if (this.$store.state.userInfo.OrganName === "朗润数据") {
                return false
            }
            if (UserGroup) {
                return UserGroup !== "app注册" || UserGroup !== "App注册"
            }
            return false
        }
    },
    filters: {
        filterOrgName (text) {
            if (String(text) === "朗润数据" || !text) return "无"
            return text
        },
        filterGroup (text, orgName) {
            if (String(orgName) === "朗润数据" || String(text) === "app注册" || String(text) === "App注册" || !text) return "无"
            return text
        }
    },
    methods: {
        // 获取用户信息
        async getUserInfo() {
            const { data } = await GetUserOrganLevelInfo();
            if (data.code === 100) {
                this.userForm = {
                    ID: data.data[0].UserId,
                    OrganName: data.data[0].organName,
                    UserGroup: data.data[0].levelName,
                    State: data.data[0].State
                };
            }
        },
        // 根据关键字获取机构信息
        async GetOrganInfo(organName) {
            const { data } = await GetOrganInfoByKeyword({
                pageSize: 15,
                sortBy: "CreateTime",
                sortOrder: "desc",
                keyWord: organName
            });
            if (data.code === 100) {
                this.organData = data.data;
            }
        },
        // 根据机构id获取用户组信息
        async GetOrganLevelInfo(value) {
            try {
                if (value) {
                    let organObj = {};
                    organObj = this.organData.find((item) => {
                        if (item.ID === value) {
                            this.organName = item.Name;
                        }
                    });
                    this.organId = value;
                    const { data } = await GetOrganLevelInfo({
                        organId: value
                    });
                    removeEmptyChildren(data.data, "children")
                    if (data.code === 100) {
                        this.organLeverData = data.data;
                    }
                }
            } catch (err) {}
        },
        // 用户组选择事件
        organLeverChange(value) {
            console.log(value)
            let nodes = this.$refs.organSelect.getCheckedNodes()
            this.organLeverName = last(nodes[0].pathLabels)
        },
        // 用户组织层级更改申请
        async UserOrganLevelApply() {
            if(!(this.organLeverId?.length)) {
                this.$message({ message: "请选择用户组！", type: "error" });
                return;
            }
            if(this.isDisable) return;
            this.isDisable = true;
            try {
                const { data } = await UserOrganLevelApply({
                    userId: this.userForm.ID,
                    organId: this.organId,
                    levelId: this.organLeverId[this.organLeverId.length - 1]
                });
                if (data.code === 100) {
                    this.$message({ message: "申请成功！", type: "success" });
                    this.organLeverId = [];
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "服务器开小差了！", type: "error" });
            } finally {
                this.isDisable = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.exam {
    width: 100%;
    height: 100%;

    .el-main {
        padding: 0 0 5px 0;
        color: black;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            border-radius: 6px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background: #bac0ca;
        }
    }
    .tab {
        width: 50px;
        height: 4px;
        background: #256cf4;
        border-radius: 2px;
    }
}

.tit {
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e8ec;

    .btns {
        height: 35px;
        box-sizing: border-box;
        margin: 0 25px 0 25px;
        cursor: pointer;
    }
}

.information {
    padding: 0px 30px;
    box-sizing: border-box;

    .line {
        margin-bottom: 30px;

        span {
            font-size: 16px;
        }

        .header {
            width: 120px;
            padding-right: 30px;
            text-align: right;
        }

        .tab-text {
            width: 360px;
        }

        // ::v-deep .el-input__inner {
        //   width: 350px;
        //   height: 40px;
        //   font-size: 14px;
        // }

        .bing-line {
            width: 100%;
            // height:60px;
            // line-height: 60px;
            border-bottom: 1px solid #e5e8ec;
        }
    }

    .saveBtn {
        width: 70px;
        height: 35px;
        background: #256cf4;
        border-radius: 4px;
        color: white;
        cursor: pointer;
    }

    .fristLine {
        margin-top: 20px;
    }
}

::v-deep .el-dialog__body {
    border-top: 1px solid #dcdfe6;
    padding: 0;
    text-align: center;
    font-size: 12px;
}

::v-deep .el-dialog__footer {
    height: 50px;
    border-top: 1px solid #dcdfe6;
    margin-top: 30px;
}
</style>
